module.exports = __webpack_public_path__ + "static/img/ajax-spinner-ring.a0e3b9e5.gif";